// removed by extract-text-webpack-plugin
module.exports = {"SubmitButton":"SubmitButton","submitButton":"SubmitButton","c-button--active":"c-button--active","cButtonActive":"c-button--active"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/SubmitButton.scss
// module id = 424
// module chunks = 0